var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drvers"},[_c('WalletsList',[_c('PageTitle',{attrs:{"title":"WALLETS.TITLE","subtitle":"TRANSPORTATION.SUBTITLE"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }